import React from 'react'
import { Modal, Button } from 'util/ui'
import { dumbLinkify } from 'util/strings'
import SanitizedHTML from 'shared/components/ui/SanitizedHTML'
import { v4 as uuidV4 } from 'uuid'
import styles from '../../styles.less'

export default class ConfirmQuestionStep extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      answer: null,
    }
    this.componentId = uuidV4()
  }

  handleNext = () => {
    const { onNext, question } = this.props
    onNext({
      question,
      answer: 'Cancel subscription',
    })
  }

  render() {
    const { onCancel, question, open } = this.props

    return (
      <Modal open={open} className={styles.billingModal}>
        <Modal.Header>Cancel account</Modal.Header>
        <Modal.Content>
          <div>
            {question.split('\n').map((item, index) => {
              const key = `${this.componentId}-${index}`
              return (
                <p key={key}>
                  <SanitizedHTML as={'span'} html={dumbLinkify(item)} />
                  <br />
                </p>
              )
            })}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button positive onClick={onCancel}>
            Nevermind, I don{"'"}t want to cancel
          </Button>
          <Button negative onClick={this.handleNext}>
            Cancel subscription
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}
